<template>
<div class="container">
    <div class="row">
        <div class="col pt-3 pb-3">
            <div class="card">
                <div class="card-body">
                    <div class="card-text">
                        <p class="lead">
                            Reset your Password
                        </p>
                        <div v-if="serverErrors.length > 0" class="alert alert-danger" role="alert">
                            <ul>
                                <li v-for="(item, index) in serverErrors" :key="index">{{item}}</li>
                            </ul>
                        </div>
                        <div class="form-group">
                            <label for="email">Email</label>
                            <input type="text" class="form-control" name="email" v-model="email" v-validate="'required|email'" :class="{'has-error': errors.has('email')}" placeholder="Email">
                            <div v-if="errors.has('email')" class="alert alert-danger mt-1">
                                {{ errors.first('email') }}
                            </div>
                        </div>
                        <div class="form-group">
                            <label for="password">Password</label>
                            <input v-model="password" v-validate="'required|min:8|verify_password'" :class="{'has-error': errors.has('password')}" name="password" type="password" class="form-control" placeholder="Password" ref="password">
                            <div v-if="errors.has('password')" class="alert alert-danger mt-1">
                                {{ errors.first('password') }}
                            </div>
                        </div>
                        <div class="form-group">
                            <label for="confirmpass">Confirm Password</label>
                            <input v-model="confirmPassword" v-validate="'required|confirmed:password'" :class="{'has-error': errors.has('password_confirmation')}" name="password_confirmation" type="password" class="form-control" placeholder="Confirm Password" data-vv-as="password">
                            <div v-if="errors.has('password_confirmation')" class="alert alert-danger mt-1">
                                {{ errors.first('password_confirmation') }}
                            </div>
                        </div>
                        <button v-on:click="resetPassword" type="submit" class="btn btn-info col-4">Reset Password</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<style>

.has-error {
    border-color: red;
}
</style>

<script>
/* eslint-disable */
import axios from 'axios'
import Router from 'vue-router'
export default {
    data() {
        return {
            serverErrors: [],
            email: '',
            password: '',
            confirmPassword: ''
        }
    },
    methods: {
        resetPassword: function (e) {
          const vm = this;
          this.$validator
            .validateAll()
            .then(function (passValidation) {
              if (passValidation) {
                axios.post('/api/Account/ResetPassword', {
                  Email: vm.email,
                  Password: vm.password,
                  ConfirmPassword: vm.confirmPassword,
                  Code: vm.$route.params.code
                }).then(function (response) {
                  vm.$router.push({name: 'ResetPasswordSuccess' });
                });
              } else {
                e.preventDefault();
              }
          })
          .catch(function () {
            e.preventDefault();
          });
        }
    }
}
</script>
